<template>
	<div class="space-y-4">
		<div class="grid grid-cols-1 md:grid-cols-6 lg:grid-cols-4 items-center justify-items-center space-y-4 text-center md:text-left">
				<img :src="icon" class="h-16 mx-auto col-span-1 md:col-span-2 lg:col-span-1"/>
			<!-- <div class="diagram-line"></div> -->
			<p class="diagram-text col-span-1 md:col-span-4 lg:col-span-3" :style="cssVariables">
				{{text}}
			</p>
		</div>
	</div>
</template>
<script>
export default {
	name: 'patient-diagram-step',
	props: {
		icon: Image,
		bgColor: String,
		textColor: {
			type: String,
			default: '#fff'
		},
		text: String
	},
	computed: {
		cssVariables() {
			return {
				'--bg-color': this.bgColor,
				'--text-color': this.textColor
			}
		}
	}
}
</script>

<style lang="postcss" scoped>
	.diagram-step-wrapper {
		display: flex;
		justify-content: space-between;
		z-index: 1;
	}
	.diagram-number-wrapper {
		display: flex;
		align-items: center;
	}
	.diagram-number {
		width: 40px;
		height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-family: theme('fontFamily.arial-bold');
		border: 3px solid theme('colors.black-blue');
		border-radius: 50%;
	}
	.diagram-line {
		width: 50px;
		border-bottom: 3px solid theme('colors.black-blue');
	}
	.diagram-text {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 1rem;
		color: var(--text-color);
		font-weight: bold;
		background-color: var(--bg-color);
	}
</style>